import { render, staticRenderFns } from "./AnnounceList.vue?vue&type=template&id=2e3f34ed&scoped=true&"
import script from "./AnnounceList.vue?vue&type=script&lang=js&"
export * from "./AnnounceList.vue?vue&type=script&lang=js&"
import style0 from "./AnnounceList.vue?vue&type=style&index=0&lang=css&"
import style1 from "./AnnounceList.vue?vue&type=style&index=1&id=2e3f34ed&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e3f34ed",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/andy1229/專案/vue_後端網頁介面參考/魚類販賣系統/shopstore_fish/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e3f34ed')) {
      api.createRecord('2e3f34ed', component.options)
    } else {
      api.reload('2e3f34ed', component.options)
    }
    module.hot.accept("./AnnounceList.vue?vue&type=template&id=2e3f34ed&scoped=true&", function () {
      api.rerender('2e3f34ed', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/reserve_system_dashboard/components/AnnounceList.vue"
export default component.exports